import { createContext, type ReactNode, useContext, useState } from 'react';
import { type NavSheetContentSections } from './models';
import { useInMediaQuery } from '@nosinovacao/nosid-mfe-common';

const NavbarContext = createContext({
  sheetOpen: false,
  setSheetOpen: (_: boolean) => {},
  activeSection: 'main' as NavSheetContentSections,
  setActiveSection: (_: NavSheetContentSections) => {},
});

type NavbarContextValue = React.ComponentProps<typeof NavbarContext.Provider>['value'];

export const useNavbarContext = () => useContext(NavbarContext);

export function NavbarContextProvider({ children }: Readonly<{ children: ReactNode }>) {
  const isDesktop = useInMediaQuery('desktop-md');
  const [sheetOpen, setSheetOpen] = useState(false);
  const [activeSection, setActiveSection] = useState<NavSheetContentSections>('main');
  const value: NavbarContextValue = {
    sheetOpen,
    setSheetOpen: (v) => {
      setSheetOpen(v);
      setTimeout(() => {
        if (!v && !isDesktop) {
          setActiveSection('main');
        }
      }, 300);
    },
    activeSection,
    setActiveSection: (v) => {
      setActiveSection(v);
      if (isDesktop && v === 'tv') setSheetOpen(true);
    },
  };
  return <NavbarContext.Provider value={value}>{children}</NavbarContext.Provider>;
}
